export var VERSION = '2.5.3';
//# sourceMappingURL=version.js.map